import axios from 'axios';

declare let core_object: any;

export default class logout{

    protected elBtn: string;
    protected elFormSpin: string = 'bgdrop-spin';
    protected url_api_logout: string;

    /**
     * Constructor
     * @param elBtn
     */
    constructor(
        elBtn: string,
    ){
        
        this.elBtn = elBtn;
        this.url_api_logout = core_object.rest_urls.comments_logout;

    }

    // Logout
    logout(){
        
        const _that = this;

        const el = document.getElementById(this.elBtn);

        el?.addEventListener("click", function(e){
            e.preventDefault();

            // Init spin
            const spin =  _that.btnSpin();

            // Append spin to button
            el?.append(spin);

            // Call ajax
            axios.post(_that.url_api_logout)
                .then(function (response: any) {

                let responseStatus: boolean = response.data.status;

                if(responseStatus == true){
                    
                    // Refresh the page
                    location.reload();
                    
                }
                    
                if(responseStatus == false){
                
                    
                
                }

            })
            .catch(function (error:any){

                let message = core_object.error_messages.general;
                

            });

        });
    
    }

    /**
     * Create spin
     * @returns 
     */
    protected btnSpin(){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', this.elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

}